import { Moment } from 'moment';

import moment from 'data/moment';
import { DateRange } from 'types/views';

const fromDates = (dates: [Moment, Moment]) => {
  const startDate = moment(dates[0]);
  const endDate = moment(dates[1]);

  return Object.values(DateRange).find((range) => {
    const dates = toDates(range);

    return dates[0].isSame(startDate) && dates[1].isSame(endDate);
  });
};

const toDates = (range: DateRange): [Moment, Moment] => {
  const startDate = moment();
  const endDate = moment();

  switch (range) {
    case DateRange.TODAY:
      // skip

      break;
    case DateRange.YESTERDAY:
      startDate.subtract(1, 'day');
      endDate.subtract(1, 'day');

      break;
    case DateRange.THIS_WEEK:
      startDate.startOf('week');
      endDate.endOf('week');

      break;
    case DateRange.LAST_WEEK:
      startDate.subtract(1, 'week').startOf('week');
      endDate.subtract(1, 'week').endOf('week');

      break;
    case DateRange.THIS_MONTH:
      startDate.startOf('month');
      endDate.endOf('month');

      break;
    case DateRange.LAST_MONTH:
      startDate.subtract(1, 'month').startOf('month');
      endDate.subtract(1, 'month').endOf('month');

      break;
    default:
      throw new Error('Range not implemented.');
  }

  return [startDate.startOf('day'), endDate.endOf('day')];
};

const dateRange = {
  fromDates,
  toDates,
};

export default dateRange;
